import { Button, Grid, Typography } from "@mui/material";
import Email from "../../assets/images/auth/email.svg";
import { useNavigate } from "react-router-dom";
import NAV from "../../utils/nav.const";
import { motion } from "framer-motion";
import styled from "styled-components";

const ForgotPasswordConfirmation = () => {
  const navigate = useNavigate();
  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.5, originY: "100px" }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.7 }}
    >
      <Grid
        container
        direction="column"
        justifyContent="center"
        alignItems="center"
        sx={{ minHeight: "80vh", textAlign: "center" }}
      >
        <Grid item xs={12} marginBottom={2}>
          <img src={Email} height={260} alt="Verify Email" />
        </Grid>
        <Grid padding={2} item xs={12}>
          <Typography color="secondary" variant="h1">
            Controleer je e-mail!
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography variant="h5">
            We hebben je een e-mail gestuurd met een link om je wachtwoord te
            wijzigen
          </Typography>
          <Typography variant="h5">
            Verifieer dit om te kunnen inloggen op uw profiel
          </Typography>
        </Grid>
        <Grid item xs={12} sx={{ margin: "20px 0" }}>
          <Button
            onClick={() => navigate(`/${NAV.SIGNIN}`)}
            variant="contained"
            sx={{ color: "#fff" }}
          >
            Inloggen
          </Button>
        </Grid>
      </Grid>
    </motion.div>
  );
};

export default ForgotPasswordConfirmation;

export const CardGrid = styled(Grid)<{
  $background?: string;
  $padding?: number;
}>`
  background: ${(props) =>
    props.$background === "indigo"
      ? "#5B41FF"
      : props.$background === "papaya"
      ? "#FF7C3A"
      : props.$background === "white"
      ? "#fff"
      : ""};
  padding: ${(props) => (props.$padding ? `${props.$padding}rem` : "")};
  min-height: 300px;
  max-height: 500px;
  width: 780px;
  border-radius: 16px;
`;
